module.exports = __webpack_public_path__ + "Kanit-Medium.87ad7842e1bf82f18acd.ttf";


//////////////////
// WEBPACK FOOTER
// /opt/app/src/assets/fonts/Kanit-Medium.ttf
// module id = ../../../../../src/assets/fonts/Kanit-Medium.ttf
// module chunks = styles